export enum ACL {
    GROUPS_CREATE = 'GROUPS_CREATE',
    GROUPS_UPDATE = 'GROUPS_UPDATE',
    GROUPS_DELETE = 'GROUPS_DELETE',
    GROUPS_GET_LIST = 'GROUPS_GET_LIST',
    GROUPS_READ = 'GROUPS_READ',
    GROUPS_ADD_USER = 'GROUPS_ADD_USER',
    GROUPS_REMOVE_USER = 'GROUPS_REMOVE_USER',
    GROUPS_GET_USERS = 'GROUPS_GET_USERS',
    GROUPS_GET_ACLS = 'GROUPS_GET_ACLS',
    GROUPS_ADD_ACL = 'GROUPS_ADD_ACL',
    GROUPS_REMOVE_ACLS = 'GROUPS_REMOVE_ACLS',
    USERS_GET_LIST = 'USERS_GET_LIST',
    USERS_GET_ACLS = 'USERS_GET_ACLS',
    USERS_ADD_ACL = 'USERS_ADD_ACL',
    USERS_REMOVE_ACL = 'USERS_REMOVE_ACL',
    TYPE_PROJECTS_CREATE = 'TYPE_PROJECTS_CREATE',
    TYPE_PROJECTS_READ = 'TYPE_PROJECTS_READ',
    TYPE_PROJECTS_DELETE = 'TYPE_PROJECTS_DELETE',
    TYPE_PROJECTS_UPDATE = 'TYPE_PROJECTS_UPDATE',
    TYPE_LAYERS_CREATE = 'TYPE_LAYERS_CREATE',
    TYPE_LAYERS_READ = 'TYPE_LAYERS_READ',
    TYPE_LAYERS_DELETE = 'TYPE_LAYERS_DELETE',
    TYPE_LAYERS_UPDATE = 'TYPE_LAYERS_UPDATE',
    USER_ADD_OBJECT_PERMISSION = 'USER_ADD_OBJECT_PERMISSION',
    USERS_REMOVE_OBJECT_PERMISSION = 'USERS_REMOVE_OBJECT_PERMISSION',
    GROUPS_ADD_OBJECT_PERMISSION = 'GROUPS_ADD_OBJECT_PERMISSION',
    GROUPS_REMOVE_OBJECT_PERMISSION = 'GROUPS_REMOVE_OBJECT_PERMISSION',
    TYPE_CATEGORIES_UPDATE = 'TYPE_CATEGORIES_UPDATE',
    TYPE_SITES_UPDATE = 'TYPE_SITES_UPDATE',
    TYPE_SITES_DELETE = 'TYPE_SITES_DELETE',
    TYPE_SITES_CREATE = 'TYPE_SITES_CREATE',
    USERS_GET = 'USERS_GET',
    TECHNICAL_PREVIEW = 'TECH_PREVIEW',
    ENABLE_ALL = 'Enable ALL ( attempt to enable multiple resource )',
}

export type AclString = keyof typeof ACL;
